import { TranslationKeys } from '~web-portal/i18n/english/help-scout-beacon.i18n';

/**
 * The maximum number of characters for a Translation value is 160.
 * https://developer.helpscout.com/beacon-2/web/javascript-api/#api-limits-2
 */

const keys: TranslationKeys = {
  helpScoutBeacon: {
    labels: {
      // Answers
      suggestedForYou: 'Réponses instantanées',
      getInTouch: 'Entrer en contact',
      searchLabel: 'Comment pouvons-nous vous aider?',
      tryAgain: 'Réessayer',
      defaultMessageErrorText:
        "Il y a eu un problème lors de l'envoi de votre message. Veuillez réessayer dans un moment.",
      beaconButtonClose: 'Fermer',
      beaconButtonChatMinimize: 'Minimiser le chat',
      beaconButtonChatOpen: 'Ouvrir le chat',

      // Ask
      answer: 'Réponses',
      ask: 'Demander',
      messageButtonLabel: 'Courriel',
      noTimeToWaitAround: "Pas le temps d'attendre? Nous répondons généralement en quelques heures",
      chatButtonLabel: 'Chat',
      chatButtonDescription: 'Nous sommes actuellement en ligne. Discutez avec notre équipe en temps réel.',
      wereHereToHelp: 'Commencer une conversation',
      whatMethodWorks: 'Quel canal préférez-vous?',
      previousMessages: 'Conversations précédentes',

      // Search results
      cantFindAnswer: 'Vous ne trouvez pas de réponse?',
      relatedArticles: 'Articles connexes',
      nothingFound: 'Hmm…',
      docsSearchEmptyText: "Nous n'avons trouvé aucun article correspondant à votre recherche.",
      tryBroaderTerm: 'Essayez de rechercher un terme plus large, ou',
      docsArticleErrorText:
        'Il y a eu un problème lors de la récupération de cet article. Veuillez vérifier votre connexion Internet et réessayer.',
      docsSearchErrorText:
        'Il y a eu un problème lors de la récupération des articles. Veuillez vérifier votre connexion Internet et réessayer.',
      escalationQuestionFeedback: 'Cette réponse a-t-elle répondu à votre question?',
      escalationQuestionFeedbackNo: 'Non',
      escalationQuestionFeedbackYes: 'Oui',
      escalationSearchText: "Parcourez nos documents d'aide pour trouver une réponse à votre question",
      escalationSearchTitle: 'Continuez à chercher',
      escalationTalkText: 'Parlez à un membre de notre équipe de support',
      escalationTalkTitle: 'Parlez-nous',
      escalationThanksFeedback: 'Merci pour vos commentaires',
      escalationWhatNext: 'Quelle est la prochaine étape?',

      // Send a message
      sendAMessage: 'Envoyer un message',
      firstAFewQuestions: 'Commençons par quelques questions',
      howCanWeHelp: 'Comment pouvons-nous vous aider?',
      responseTime: 'Nous répondons généralement en quelques heures',
      history: 'Historique',
      uploadAnImage: 'Téléverser une image',
      attachAFile: 'Joindre un fichier',
      continueEditing: 'Continuer à écrire…',
      lastUpdated: 'Dernière mise à jour',
      you: 'Vous',
      nameLabel: 'Nom',
      subjectLabel: 'Sujet',
      emailLabel: 'Adresse courriel',
      messageLabel: 'Comment pouvons-nous vous aider?',
      messageSubmitLabel: 'Envoyer un message',
      next: 'Suivant',
      weAreOnIt: 'Nous nous en occupons!',
      messageConfirmationText: 'Vous recevrez une réponse par courriel dans quelques heures.',
      viewAndUpdateMessage: 'Vous pouvez voir et mettre à jour votre message dans',
      mayNotBeEmpty: 'Ne peut pas être vide',
      customFieldsValidationLabel: 'Veuillez remplir tous les champs',
      emailValidationLabel: 'Veuillez utiliser une adresse courriel valide',
      attachmentErrorText:
        'Il y a eu un problème lors du téléversement de votre pièce jointe. Veuillez réessayer dans un moment.',
      attachmentSizeErrorText: 'Les pièces jointes ne peuvent pas dépasser 10 Mo',

      // Previous messages
      addReply: 'Ajouter une réponse',
      addYourMessageHere: 'Ajoutez votre message ici...',
      sendMessage: 'Envoyer le message',
      received: 'Reçu',
      waitingForAnAnswer: "En attente d'une réponse",
      previousMessageErrorText:
        'Il y a eu un problème lors de la récupération de ce message. Veuillez vérifier votre connexion Internet et réessayer.',
      justNow: "À l'instant",

      // Chat
      chatHeadingTitle: 'Discuter avec notre équipe',
      chatHeadingSublabel: 'Nous serons avec vous bientôt',
      chatEndCalloutHeading: 'Tout est fait!',
      chatEndCalloutMessage: 'Une copie de cette conversation sera envoyée dans votre boîte de réception sous peu.',
      chatEndCalloutLink: "Retour à l'accueil",
      chatEndUnassignedCalloutHeading: 'Désolé pour ce désagrément',
      chatEndUnassignedCalloutMessage:
        "Il semble que personne n'ait pris votre chat. Nous vous enverrons une réponse par courriel dès que possible.",
      chatEndWaitingCustomerHeading: 'Désolé pour ce désagrément',
      chatEndWaitingCustomerMessage:
        "Votre question a été ajoutée à notre file d'attente de courriels et nous vous répondrons sous peu.",
      ending: 'Fin...',
      endChat: 'Terminer',
      chatEnded: ' a terminé le chat',
      chatConnected: 'Connecté à ',
      chatbotName: "Bot d'aide",
      chatbotGreet:
        "Bonjour! Vous pouvez commencer par poser votre question ci-dessous. Quelqu'un sera avec vous sous peu.",
      chatbotPromptEmail:
        "Compris. Très rapidement, quelle est votre adresse courriel? Nous l'utiliserons pour tout message de suivi.",
      chatbotConfirmationMessage: "Merci! Quelqu'un de notre équipe va bientôt rejoindre le chat.",
      chatbotGenericErrorMessage:
        "Un problème est survenu lors de l'envoi de votre message, veuillez réessayer dans quelques minutes.",
      chatbotInactivityPrompt: 'Puisque le chat est devenu inactif, je vais terminer ce chat dans quelques minutes.',
      chatbotInvalidEmailMessage: 'Il semble que vous ayez entré une adresse courriel invalide. Voulez-vous réessayer?',
      chatbotAgentDisconnectedMessage:
        " s'est déconnecté. Il est possible qu'il ait perdu sa connexion Internet, donc je cherche quelqu'un d'autre pour prendre le relais. Désolé pour le délai!",
      chatAvailabilityChangeMessage:
        "La disponibilité de notre équipe a changé et il n'y a plus personne disponible pour discuter. Envoyez-nous un message à la place et nous vous répondrons.",

      // Transcript email
      emailHeading: "Le chat d'aujourd'hui avec ",
      emailGreeting: 'Salut ',
      emailCopyOfDiscussion: 'Voici une copie de votre discussion',
      emailContinueConversation:
        "Si vous avez d'autres questions, n'hésitez pas à répondre et à continuer la conversation.",
      emailJoinedLineItem: ' a rejoint le chat',
      emailEndedLineItem: ' a terminé le chat',
      emailYou: 'Vous',
    },
  },
};

export default keys;
